import React from 'react';
import { HorizontalLine } from './HorizontalLine';

type TypeInfoProps = {
    typeHead?: 'Component' | 'Type';
    name?: string;
    description?: string;
};

type TypeNameProps = {
    typeHead: 'Component' | 'Type';
    name: string;
};

type TypeDescriptionProps = {
    description: string;
};

export const TypeName: React.FC<TypeNameProps> = ({ typeHead, name }) => (
    <div
        style={{
            color: '#9c9c9c',
            fontSize: '12px',
        }}
    >
        <span>{typeHead}:</span>
        <span
            style={{
                display: 'inline-block',
                marginLeft: '5px',
                fontStyle: 'italic',
                color: '#595959',
            }}
        >
            {name}
        </span>
    </div>
);

export const TypeDescription: React.FC<TypeDescriptionProps> = ({ description }) => (
    <div
        style={{
            color: '#9c9c9c',
            fontSize: '12px',
        }}
    >
        <span>Description:</span>
        <span
            style={{
                display: 'inline',
                marginLeft: '5px',
                fontStyle: 'italic',
                color: '#595959',
            }}
        >
            {description}
        </span>
    </div>
);

export const TypeInfo: React.FC<TypeInfoProps> = ({ typeHead = 'Component', name = '', description = 'none' }) => {
    return (
        <>
            {typeHead && name && (
                <div>
                    <TypeName typeHead={typeHead} name={name} />
                </div>
            )}

            {description && (
                <div style={{ marginTop: '0', color: '#9c9c9c', fontSize: '12px' }}>
                    <TypeDescription description={description} />
                </div>
            )}

            <HorizontalLine />
        </>
    );
};
